import React from 'react';
import PropTypes from 'prop-types';

import OrderProduct from './order-product';
import OrderDeliveryFee from './order-delivery-fee';
import OrderDiscountsTotal from './order-discounts-total';
import OrderSurcharge from './order-surcharge';
import OrderTip from './order-tip';
import OrderTotal from './order-total';

class OrderItems extends React.Component {
    static propTypes = {
        products: PropTypes.array.isRequired,
        delivery_fee: PropTypes.object.isRequired,
        discounts_total: PropTypes.object.isRequired,
        surcharge: PropTypes.object.isRequired,
        total: PropTypes.object.isRequired,
        tax_totals: PropTypes.array.isRequired,
        currency_abrv: PropTypes.string.isRequired,
    };

    render() {
        return (
            <table className="m2g-order-confirmation-items m2g-table">
                <tbody>
                    {this.props.products.map(product => {
                        return (
                            <OrderProduct product={product} key={product.cid} />
                        );
                    })}

                    {this.props.delivery_fee.toFloat() !== 0.0 && (
                        <OrderDeliveryFee
                            delivery_fee={this.props.delivery_fee}
                        />
                    )}
                    {this.props.discounts_total.toFloat() !== 0.0 && (
                        <OrderDiscountsTotal
                            discounts_total={this.props.discounts_total}
                        />
                    )}
                    {this.props.surcharge.toFloat() !== 0.0 && (
                        <OrderSurcharge surcharge={this.props.surcharge} />
                    )}
                    {this.props.tip.toFloat() !== 0.0 && (
                        <OrderTip tip={this.props.tip} />
                    )}
                    <OrderTotal
                        total={this.props.total}
                        tax_totals={this.props.tax_totals}
                        currency_abrv={this.props.currency_abrv}
                    />
                </tbody>
            </table>
        );
    }
}

export default OrderItems;
